import ms, { StringValue } from 'ms';

import { useToastStore } from './toast.store';
import { ToastConfig, ToastVariant } from './toast.store.types';

const DEFAULT_DURATION: StringValue = '5s';

const createToast = (
  variant: ToastVariant,
  message: React.ReactNode,
  config?: Omit<ToastConfig, 'message'>,
): string => {
  const id = config?.id ?? `toast-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

  const duration = ms(config?.duration ?? DEFAULT_DURATION);

  useToastStore.getState().addToast({
    id,
    message,
    variant,
    duration,
    createdAt: Date.now(),
    persist: config?.persist,
    title: config?.title,
  });

  return id;
};

export const toast = {
  success: (message: React.ReactNode, config?: Omit<ToastConfig, 'message'>) => createToast('success', message, config),
  error: (message: React.ReactNode, config?: Omit<ToastConfig, 'message'>) => createToast('error', message, config),
  info: (message: React.ReactNode, config?: Omit<ToastConfig, 'message'>) => createToast('info', message, config),
  warning: (message: React.ReactNode, config?: Omit<ToastConfig, 'message'>) => createToast('warning', message, config),
  dismiss: (id: string) => useToastStore.getState().removeToast(id),
  clearAll: () => useToastStore.getState().clearAll(),
};
